import { buildWorkspaceQuery, workspaceRequest } from "./workspaceApiShared";

export function getWorkspaceHostSupportDashboard(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/host-support`, {
    token,
    fallback: "Unable to load workspace host support data.",
  });
}

export function listWorkspaceHostSupportEvents(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/host-support/service-events`, {
    token,
    fallback: "Unable to load workspace service events.",
  });
}

export function createWorkspaceHostSupportEvent(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/host-support/service-events`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to save the workspace service event.",
  });
}

export function listWorkspaceFollowUpCases(workspaceId, token, params = {}) {
  return workspaceRequest(
    `/workspaces/${workspaceId}/host-support/follow-up-cases${buildWorkspaceQuery(params)}`,
    {
      token,
      fallback: "Unable to load follow-up cases.",
    }
  );
}

export function createWorkspaceFollowUpCase(workspaceId, payload, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/host-support/follow-up-cases`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to open the follow-up case.",
  });
}

export function updateWorkspaceFollowUpCaseStatus(
  workspaceId,
  caseId,
  payload,
  token
) {
  return workspaceRequest(
    `/workspaces/${workspaceId}/host-support/follow-up-cases/${caseId}/status`,
    {
      method: "POST",
      token,
      body: payload,
      fallback: "Unable to update the follow-up case.",
    }
  );
}

export function getMyOperatorAffiliations(token) {
  return workspaceRequest("/myboothshare/account/operator-affiliations", {
    token,
    fallback: "Unable to load operator affiliations.",
  });
}
